import StatusPill from "./StatusPill";

interface ExperienceItemProps {
  role: string;
  company: string;
  period: string;
  current: boolean;
  points: string[];
  animationClass?: string;
}

function ExperienceItem(props: ExperienceItemProps) {
  const {
    role,
    company,
    period,
    current,
    points,
    animationClass = "animate-fade-in",
  } = props;

  return (
    <div className={`opacity-0-start ${animationClass} flex gap-5 relative`}>
      {/* Timeline dot + line */}
      <div className="flex flex-col items-center pt-1.5">
        <div
          className={[
            "w-2.5 h-2.5 rounded-full flex-shrink-0",
            current
              ? "bg-accent border-2 border-accent shadow-glow"
              : "bg-border border-2 border-content-muted",
          ].join(" ")}
        />
        <div className="w-px flex-1 bg-border mt-1.5" />
      </div>

      {/* Content */}
      <div className="flex-1 pb-8">
        <div className="flex flex-wrap items-center gap-2.5 mb-1">
          <h3 className="text-md font-semibold text-content">{role}</h3>
          {current ? <StatusPill color="accent">Current</StatusPill> : null}
        </div>

        <div className="flex items-center gap-2 mb-3">
          <span className="text-sm text-brand font-medium">{company}</span>
          <span className="text-xs text-content-muted font-mono">{period}</span>
        </div>

        <ul className="flex flex-col gap-2 list-none p-0 m-0">
          {points.map((p: string, i: number) => (
            <li
              key={i}
              className="text-sm text-content-secondary leading-relaxed pl-4 relative"
            >
              <span className="absolute left-0 top-2 w-1 h-1 rounded-full bg-content-muted" />
              {p}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ExperienceItem;